import {
  Dialog,
  DialogContent as MuiDialogContent,
  Grid,
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
  CircularProgress as MuiCircularProgress,
} from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components/macro";
import { sizing, spacing } from "@mui/system";
import convertUSD from "../../../utils/convertUSD";

const DialogContent = styled(MuiDialogContent)(spacing);

const CircularProgress = styled(MuiCircularProgress)`
  ${spacing};
  ${sizing};
`;

const WithdrawConfirm = ({ loading, amount, open, onConfirm, onCancel }) => {
  const [success, setSuccess] = useState(false);

  return (
    <Dialog open={open} onClose={loading ? () => {} : onCancel}>
      <DialogContent sx={{ maxWidth: "600px" }} px={40} py={15}>
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12}>
            <Stepper activeStep={2}>
              {[0, 1, 2].map((step) => (
                <Step key={step} completed={success || step < 2}>
                  <StepLabel />
                </Step>
              ))}
            </Stepper>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" textAlign="center">
              {success
                ? `Completed Withdraw of ${convertUSD(amount)}`
                : `Are you sure you want to Withdraw ${convertUSD(
                    amount
                  )} to Check?`}
            </Typography>
          </Grid>
          {loading && (
            <Grid item xs={12}>
              <Typography textAlign="center">
                <CircularProgress size={24} ml={3} />
              </Typography>
            </Grid>
          )}
          <Grid item xs="auto">
            {success ? (
              <Button variant="contained" color="primary" onClick={onCancel}>
                Ok
              </Button>
            ) : (
              <Grid container spacing={5} justifyContent="center">
                <Grid item xs="auto">
                  <Button color="primary" onClick={onCancel} disabled={loading}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs="auto">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      try {
                        await onConfirm();
                        setSuccess(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    disabled={loading}
                  >
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default WithdrawConfirm;
